import { render, staticRenderFns } from "./GnbTop.vue?vue&type=template&id=2a2236f0"
import script from "./GnbTop.ts?vue&type=script&lang=js&external"
export * from "./GnbTop.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports